<template>
  <section class="userManagedServices">
    <!-- v-if="newManagedServices.registrationStep === 'listing'" -->
    <!-- <v-container
      mt-3
      fluid
      class="header">
      <v-layout row >
        <v-flex
          xs12
          sm5
          md4>
          <v-card>
            <div class="opportunity-lookup">
              <h4>Look up Opportunity Registration</h4>
              <v-form @submit.prevent="onSearchOpportunityId">
                <v-text-field
                  v-model.trim="searchId"
                  :success="!newManagedServices.searchError"
                  :error="newManagedServices.searchError"
                  :messages="newManagedServices.searchMessage"
                  :loading="newManagedServices.searching"
                  label="Enter Opportunity ID"
                  solo
                  outlined
                  append-icon="search"
                  dark
                  @click:append="onSearchOpportunityId"
                />
              </v-form>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container> -->
    <!-- v-if="newManagedServices.registrationStep === 'listing'" -->
    <!-- <formUserManagedServicesList /> -->
    <v-container fluid>
      <v-layout>
        <v-flex md12>
          <material-card>
            <v-progress-linear
              v-slot:progress
              v-if="managedServicesList.loadingList"
              color="orange"
              indeterminate/>
            <v-data-table
              :headers="managedServicesList.listHeaders"
              :items="listMngServices"
              v-model="selected"
              hide-actions
              item-key="Managed_Services_Id"
              loading-text="Loading... Please wait"
            >
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text-md-left text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr :active="props.selected">
                  <td>
                    <v-icon
                      color="orange"
                      class="mr-2"
                      title="View Reequest"
                      @click="editItem(props.item)">
                      visibility
                    </v-icon>
                  </td>
                  <td>{{ props.item.Opportunity_Id }}</td>
                  <td>{{ props.item.AWS_Accounts }} </td>
                  <td>{{ props.item.Description }}</td>
                  <td>{{ props.item.Status }}</td>
                </tr>
              </template>
            </v-data-table>
            <v-progress-linear
              v-slot:progress
              v-if="managedServicesList.loadingList"
              color="orange"
              indeterminate/>
            <div class="text-xs-center mt-3">
              <v-btn :disabled="!managedServicesList.nextPaginationKey || managedServicesList.loadingList" small @click="showNextData">LOAD MORE...</v-btn>
            </div>
          </material-card>
        </v-flex>
      </v-layout>
    </v-container>
    <div>
      <v-dialog large v-model="updateManagedServices.showDialog" persistent scrollable max-width="1300px">
        <v-card>
          <v-card-title class="dialog-title">
            <span>Customer Owned Accounts - Request Managed Svcs</span>
          </v-card-title>
          <v-card-text id="update-dialog-content">
            <v-container
              fluid
              style="padding: 0">
              <v-layout
                row
                wrap>
                <v-flex
                  xs12
                  sm12
                  md12
                  xl12>
                  <v-container
                    v-if="(currentPage === 'page1')"
                    class="request-details-p1">
                    <v-layout row align-center class="form-row p1">
                      <v-flex
                        md6
                        pt-2
                        class="d-flex align-center">
                        <label>Describe any customization per the SOW that deviates from the standard Gold Managed Services.</label>
                      </v-flex>
                      <v-flex
                        md6>
                        <v-textarea
                          v-model="updateManagedServices.data.Description"
                          placeholder=""
                          name="description"
                          solo
                          readonly
                        />
                      </v-flex>
                    </v-layout>
                    <v-layout row align-center class="form-row">
                      <v-flex
                        md6
                        pt-2
                        class="d-flex align-center">
                        <label>List the Client owned AWS Account ID numbers to which the Gold Managed Services need to be deployed. </label>
                      </v-flex>
                      <v-flex
                        md6>
                        <!-- <v-autocomplete
                          v-model="updateManagedServices.data.AWS_Accounts"
                          :items="awsAccountList"
                          item-text="Customer_Name"
                          item-value="Customer_Id"
                          persistent-hint
                          open-on-clear
                          attach
                          multiple
                          chips
                          small-chips
                          solo
                        /> -->
                        <v-text-field
                          v-model="updateManagedServices.data.AWS_Accounts"
                          label="Email"
                          placeholder="Email"
                          solo
                          readonly
                        />
                      </v-flex>
                    </v-layout>
                    <v-layout row align-center class="form-row">
                      <v-flex
                        md6
                        pt-2
                        class="d-flex align-center">
                        <label>List the AWS region(s) where the Gold Managed Services need to be deployed</label>
                      </v-flex>
                      <v-flex
                        md6>
                        <v-autocomplete
                          v-model="updateManagedServices.data.AWS_Regions"
                          :items="managedServicesList.regions"
                          :readonly="updateManagedServices"
                          item-text="label"
                          item-value="value"
                          persistent-hint
                          open-on-clear
                          attach
                          multiple
                          chips
                          small-chips
                          solo
                        />
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex md11/>
                      <v-flex md3>
                        <v-btn
                          @click="closeDialog">
                          CLOSE
                        </v-btn>
                        <v-btn
                          class="auto"
                          color="success"
                          @click="continueToNextStep('page2')">
                          CONTINUE
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>

                  <v-container v-if="(currentPage === 'page2')" class="request-details-p2">
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md5>
                        <v-text-field
                          :rules="['Valid WBS Code is required']"
                          v-model="awsAccountValidation.wbsCode"
                          :loading="awsAccountValidation.wbsValidating"
                          :success="awsAccountValidation.wbsCodeValidated"
                          :error="!awsAccountValidation.wbsCodeValidated"
                          :messages="awsAccountValidation.wbsValidationMessage"
                          label="Enter WBS Code"
                          outlined
                          @keypress="onWbsChange"
                          readonly
                        >
                          <template v-slot:append>
                            <v-btn
                              :color="awsAccountValidation.wbsCodeValidated ? 'orange' : ''"
                              class="my-0"
                              small
                              @click="onWbsValidate"
                            >
                              <span
                                v-if="!awsAccountValidation.wbsCodeValidated"
                              >validate</span>
                              <v-icon small v-else>check</v-icon>
                            </v-btn>
                          </template>
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 offset-md1 md6>
                        <v-text-field
                          v-model="awsAccountValidation.wbsType"
                          label="WBS Type"
                          placeholder="WBS Type"
                          messages="WBS Type shows here once WBS code is valid"
                          disabled
                          solo
                          readonly
                        />
                      </v-flex>
                      <v-flex xs12 sm6 md5>
                        <v-text-field
                          v-if="awsAccountValidation.wbsType == 'L-CSC-NonUS WBS'"
                          v-model="awsAccountValidation.iwoCode"
                          :loading="awsAccountValidation.iwoValidating"
                          :success="awsAccountValidation.iwoCodeValidated"
                          :error="!awsAccountValidation.iwoCodeValidated"
                          :messages="awsAccountValidation.iwoValidationMessage"
                          label="Enter IWO Code"
                          @keypress="onIwoChange"
                          readonly
                        >
                          <template v-slot:append>
                            <v-btn
                              :color="awsAccountValidation.iwoCodeValidated ? 'orange' : ''"
                              class="my-0"
                              small
                              @click="onIwoValidate"
                            >
                              <span
                                v-if="!awsAccountValidation.iwoCodeValidated"
                              >validate</span>
                              <v-icon small v-else>check</v-icon>
                            </v-btn>
                          </template>
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex md12>
                        <div
                          v-if="awsAccountValidation.wbsCodeValidated"
                          v-bind:class="{ les: awsAccountValidation.wbsType == 'L-ES WBS' }" 
                          class="acknowledged-section mt-3">
                          <p>NOTE: Please ensure that your WBS code is set up with the correct Major Offering codes </p>
                          <p><b>L-ES WBS Codes</b> should be aligned to <b>service line IDATD 6N or ICSEP 6N</b></p>
                          <div 
                            v-if="awsAccountValidation.wbsType == 'L-ES WBS' || awsAccountValidation.wbsType == 'L-CSC-US WBS'"
                            class="wbs-agreement">
                            <p>To validate the major offering code using the following link. The category on the request should be WBS Lookup. <a href='https://dxcportal.sharepoint.com/sites/operationRequest/Lists/OPS%20Requests/Item/newifs.aspx?Source=https%3a//dxcportal.sharepoint.com/sites/operationRequest/SitePages/Home.aspx' target="_blank">https://dxcportal.sharepoint.com/sites/operationRequest/Lists/OPS%20Requests/Item/newifs.aspx?Source=https%3a//dxcportal.sharepoint.com/sites/operationRequest/SitePages/Home.aspx</a></p>
                          </div>
                          <div class="iwo-agreement" v-else>
                            <ul>
                              <li>GSAP WBS Codes should be aligned to Offering Portfolio – O_P1322168</li>
                              <li>C1 WBS Codes should be under C1 Profit Center – P1322168</li>
                              <li>To validate the C1 profit center you can look up your WBS under the here: <a href="https://myfrats.csc.com">https://myfrats.csc.com</a></li>
                            </ul>
                            <br>
                          </div>

                          <p> If your WBS Code is set up under any offering other than AWS Cloud Service (I-AWS) please work with your local finance resource to get a code set up under
                          <b>Major Offering Code I-AWS</b></p>
                          <v-checkbox
                            :disabled="!awsAccountValidation.iwoCodeValidated && awsAccountValidation.wbsType == 'L-CSC-NonUS WBS'"
                            v-model="awsAccountValidation.agreed"
                            light
                            class="mx-2 confirm-validation"
                            color="white"
                            label="I understand and have validated that the major offering code is properly selected."
                          />
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex
                        md6
                        pt-2
                        class="d-flex align-center">
                        <label>Who is the DXC client account team financial owner of the WBS/IWO?</label>
                      </v-flex>
                      <v-flex
                        md6>
                        <v-text-field
                          v-model="updateManagedServices.data.Client_Email_List"
                          label="Email"
                          placeholder="Email"
                          solo
                          readonly
                        />
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex
                        md6
                        pt-2
                        class="d-flex align-center">
                        <label>Who is the DXC account contact to receive the Offering Access code after approvals by DXC AWS Practice?</label>
                      </v-flex>
                      <v-flex
                        md6>
                        <v-text-field
                          v-model="updateManagedServices.data.Offering_Access_Email"
                          label="Email"
                          placeholder="Email"
                          solo
                          readonly
                        />
                      </v-flex>
                    </v-layout>
                    <!-- <v-layout>
                      <v-flex
                        md2
                        pt-2
                        class="d-flex align-center">
                        <label>Account ID</label>
                      </v-flex>
                      <v-flex
                        md4>
                        <v-text-field
                          v-model="updateManagedServices.data.AccountID"
                          label="Account ID"
                          placeholder="Account ID"
                          solo
                          readonly
                        />
                      </v-flex>
                    </v-layout> -->
                    <v-layout>
                      <v-flex
                        md6
                        pt-2
                        class="d-flex align-center">
                        <label>Who is in charge? </label>
                      </v-flex>
                      <v-flex md6 />
                    </v-layout>
                    <v-layout>
                      <v-flex
                        md6>
                        <v-text-field
                          v-model="updateManagedServices.data.InChargeName"
                          label="Name"
                          placeholder="Name"
                          solo
                          readonly
                        />
                      </v-flex>
                      <v-flex
                        md6>
                        <v-text-field
                          v-model="updateManagedServices.data.InChargeEmail"
                          label="Email"
                          placeholder="Email"
                          solo
                          readonly
                        />
                      </v-flex>
                    </v-layout>
                    <v-layout align-end>
                      <v-flex md8/>
                      <v-flex md4>
                        <v-btn
                          @click="closeDialog">
                          CLOSE
                        </v-btn>
                        <v-btn
                          @click="PreviousPage">
                          PREVIOUS PAGE
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </section>

</template>
<script>
import { mapMutations, mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      currentPage: 'page1',
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      },
    }
  },
  computed: {
    ...mapState('user/requestManagedServices', [
      'managedServicesList',
      'updateManagedServices',
      'awsAccountList',
      'awsAccountValidation'
    ]),
    listMngServices () {
      return this.managedServicesList.listManagedServices
    },
    selected: {
      get () {
        console.log('setSelectedWorkload get')
        return this.managedServicesList.selectedWorkload
      },
      set (val) {
        console.log('setSelectedWorkload set', val)
        this.setSelectedWorkload(val)
      }
    }
  },
  beforeDestroy () {
  },
  mounted () {
    this.$store.dispatch('user/requestManagedServices/getManagedServices', {})
    this.$store.dispatch('user/requestManagedServices/getAccountList')
  },
  methods: {
    editItem (item) {
      console.log('editItem', item)
      this.$store.commit('user/requestManagedServices/showUpdateDialog', item)
    },
    closeDialog () {
      this.$store.commit('user/requestManagedServices/closeDialog', true)
    },
    onWbsChange () {
      this.newManagedServices.wbsCodeValidated = false
      this.newManagedServices.wbsValidationMessage = ''
    },
    onWbsValidate () {
      this.$store.dispatch('user/requestManagedServices/validateWbsCode', this.awsAccountValidation.wbsCode)
    },
    continueToNextStep (page) {
      console.log('continueToNextStep', page)
      this.currentPage = page
    },
    PreviousPage () {
      this.currentPage = 'page1'
    },
    showNextData () {
      this.$store.dispatch('user/requestManagedServices/getManagedServices', { nextPaginationKey: this.managedServicesList.nextPaginationKey })
    }
    // submitData () {
    //   this.currentPage = 'submit'
    //   this.searchId = ''
    //   const selectedOPX_Id = this.managedServicesList.selectedWorkload
    //   const AWS_Accounts = this.newManagedServices.AWS_Accounts
    //   const AWS_Regions = this.newManagedServices.AWS_Regions
    //   const Client_Email_List = this.newManagedServices.Client_Email_List
    //   const Offering_Access_Email = this.newManagedServices.Offering_Access_Email

    //   const params = {
    //     Description: this.newManagedServices.Description,
    //     AWS_Accounts: AWS_Accounts,
    //     AWS_Regions: AWS_Regions.toString(),
    //     WBS_Code: this.awsAccountValidation.wbsCode,
    //     WBS_Type: this.awsAccountValidation.wbsType,
    //     Opportunity_Id: selectedOPX_Id[0].SFDC_Id,
    //     Client_Email_List: Client_Email_List.toString(),
    //     Offering_Access_Email: Offering_Access_Email.toString(),
    //     AccountID: this.newManagedServices.AccountID,
    //     InChargeName: this.newManagedServices.InChargeName,
    //     InChargeEmail: this.newManagedServices.InChargeEmail,
    //     Status: 'New'
    //   }
    //   this.$store.dispatch('user/requestManagedServices/submitManagedServices', params)
    //   this.$store.dispatch('user/requestManagedServices/getManagedServices', {})
    // }
  }
}
</script>
<style lang="scss" >
.userManagedServices {
  // padding: 15px 0;
  background-color: #fff;
  height:100%;

  .header {
    .opportunity-lookup {
      padding: 10px;
      background: #000;
      color: #fff;
    }

    .opportunity-details {
      background: #000;
      color: #fff;
      padding: 10px 10px 20px 10px;

      [type=text] {
        color: #fff;
      }
    }
    .search-opp {
      background-color: #000;
      margin: 15px 15px;
      padding: 25px 15px;
      .v-messages {
        min-height: 0 !important;
      }
      .v-text-field.v-text-field--enclosed .v-text-field__details {
        margin-bottom: 0;
      }
    }

    .v-text-field__slot .v-label {
      color: #fff !important;
    }
  }
}

.view-link {
  cursor: pointer;
  color: #ff9900 !important;
}
table.v-table thead th {
  font-weight: 600;
}

section.userAwsAccount {
  .search-opp {
    background-color:#000;
    margin:15px 15px;
    padding:25px 15px
  }
  table.v-table thead th {
    font-weight: 600;
  }

  .v-datatable thead th {
    // background-color: #000;
    // color: #fff;
    font-weight: 400;

    span {
      // color: #fff !important;
      font-size: 14px !important;
      font-weight: 500 !important;
    }
  }
}
.request-details {
  border-top: 1px solid lightgray;
  margin: 25px;
  padding: 0px 0px 25px 0px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 3px;

  .form-row {
    margin-bottom: 20px;
  }
}
.section-header {
  margin: 0px 0px 25px 0px;
  padding: 0px;
}
.section-header-title {
  background-color:#000;
  color: #fff;
  padding:0 15px
}
.acknowledged-section {
  padding: 20px;
  background: #ff9900;
  margin-bottom: 20px;

  &.les {
    background: yellow;
  }

  a {
    color: #000;
    text-decoration: underline;
  }
}

.confirm-validation {
  label {
    color: #000 !important;
    font-weight: 500 !important;
  }
}
.submitLoading {
  padding: 50px 0px;
}
</style>
